module.exports = __webpack_public_path__ + "f746fe8f49ddc406c4a36ac24fa7463b.pdf";